import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DynamicFormLoginModule } from 'common/dynamic-form/dynamic-form-login.module';

import { CopyrightModule } from './copyright/copyright.module';
import { DocumentsModule } from './documents/documents.module';
import { LoginFormComponent } from './login-form.component';
import { RegisterModule } from './register/register.module';
import { SocialModule } from './social/social.module';

@NgModule({
  declarations: [LoginFormComponent],
  imports: [
    CommonModule,
    DynamicFormLoginModule,
    SocialModule,
    RegisterModule,
    DocumentsModule,
    CopyrightModule,
  ],
  exports: [LoginFormComponent],
  bootstrap: [LoginFormComponent],
})
export class LoginFormModule {}
